import { INVENTORY_REPORT, PRODUCT_SALES_REPORT, STOCK_IN_REPORT } from "./types";


export const inventoryReportAction = (data, onSuccess, onError) => {
    return {
        type: INVENTORY_REPORT,
        data,
        onSuccess,
        onError,
    };
};

export const stockInReportAction = (data, onSuccess, onError) => {
    return {
        type: STOCK_IN_REPORT,
        data,
        onSuccess,
        onError,
    };
};

export const productSalesReportAction = (data, onSuccess, onError) => {
    return {
        type: PRODUCT_SALES_REPORT,
        data,
        onSuccess,
        onError,
    };
};
